import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { filterUndefinedOrNull } from 'utils/filter';
import { appendQueryParams } from 'utils/url';

const useShareLink = ({ domain }) => {
    const { isMgmShare = false, isMgmSelf = false } = useSelector(s => s.flags);
    const getShareUrl = ({ testCode, promoId, promoUUID, entryId, entryUUID, referralCode }) => {
        const shouldGetMgmLink = isMgmSelf || isMgmShare;
        const urlQuery = {
            utm_source: `promo_${promoId}`,
            utm_medium: 'friend_referral',
            utm_campaign: shouldGetMgmLink ? 'fever_mgm' : 'fever_share',
            utm_content: shouldGetMgmLink ? referralCode : entryId,
            serialno: entryId,
            entryUuid: entryUUID,
            test_code: testCode?.test_code,
            test_expired: testCode?.test_expired,
            ts: Date.now()
        };
        let baseUrl = `https://${domain}/r/promotions/${
            shouldGetMgmLink ? 'mgm' : 'share'
        }/${promoUUID}`;

        return appendQueryParams(baseUrl, filterUndefinedOrNull(urlQuery));
    };

    return useCallback(getShareUrl, [domain, isMgmSelf, isMgmShare]);
};

export default useShareLink;
